module.exports = __webpack_public_path__ + "media/images/countryrect/et-ccfe85c4dbbf6bb8fa9b2eb1070b1f79.svg";